/**
 * Query keys for profile queries.
 *
 * Kept in this leaf module (not in `lib/services/profile/hooks.tsx`) so the
 * factory initialises eagerly with no imports — the same convention every other
 * query-key set here follows. Co-locating it inside the react-refresh-registered
 * hooks module made it reachable through a circular import before its
 * initializer ran, which surfaced as a `Cannot access 'profileKeys' before
 * initialization` TDZ error under Storybook's react-refresh. `hooks.tsx`
 * re-exports this for backward compatibility.
 */
export const profileKeys = {
  all: ['profile'] as const,
  user: () => [...profileKeys.all, 'user'] as const
};
